import { makeStyles } from "@material-ui/core"

export const useAccountMenuStyles = makeStyles(theme => ({
  menuItemLevel1: {
    whiteSpace: "normal",
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1),
    minHeight: 36,
    backgroundColor: theme.palette.grey[100],
    "&:hover": {
      backgroundColor: theme.palette.grey[200],
    },
  },
  menuItemIcon: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(1),
  },
  menuItemLabel: {
    fontSize: "0.8125rem",
    fontWeight: 500,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
  menuItemSublabel: {
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.02em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    lineHeight: 1.2,
  },
  menuItemValue: {
    fontSize: "0.8125rem",
    fontWeight: 500,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
  expandIcon: {
    color: theme.palette.text.secondary,
  },
  section: {
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  nestedList: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.5),
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    borderRadius: theme.shape.borderRadius,
    boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`,
  },
  nestedItem: {
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(1.25),
    paddingRight: theme.spacing(1),
    minHeight: 28,
  },
  nestedItemText: {
    margin: 0,
  },
  nestedItemLabel: {
    fontSize: "0.75rem",
    lineHeight: 1.35,
  },
  selectedItem: {
    backgroundColor: theme.palette.action.selected,
    "& $nestedItemLabel": {
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
  },
}))
